var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vueTour" }, [
    _c(
      "i",
      { staticClass: "material-icons helpIcon", on: { click: _vm.showHelp } },
      [_vm._v("\n    help_outline\n    ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }